import autocompleteHtml from './autocomplete.html';
import './autocomplete.scss';

class AutocompleteDirective {
    constructor() {

        this.restrict = 'AE';
        this.scope = {
            model: '=',
            options: '=',
            ngDisabled: '=',
            placeholder: '@',
            customClass: '@',
            submit: '&',
            select: '&'
        };
        this.replace = true;
        this.transclude = true;
        this.controllerAs = '$ctrl';
        this.bindToController = true;
        this.template = autocompleteHtml;
        this.controller = AutocompleteDirectiveController;
    }

    static directiveFactory() {
        'ngInject';
        return new AutocompleteDirective();
    }
}

class AutocompleteDirectiveController {
    constructor($scope, $sce, $filter) {
        'ngInject';

        this.$scope = $scope;
        this.$sce = $sce;
        this.$filter = $filter;

        this.selected = -1;
        this.omitNextAutocomplete = false;
        this.showOptions = false;

        this.$scope.$watch(
            () => this.options,
            (newVal) => {
                this.autocomplete(this.model);
            },
            true
        );
    }

    clickOption(rawMatch) {
        this.showOptions = false;
        this.omitNextAutocomplete = true;
        this.model = rawMatch.name;

        if (this.select) {
            this.select({match: rawMatch});
        }
    }

    selectOption(option) {
        this.model = option;
        this.showOptions = false;
        this.filteredOptions = [];

        if (this.submit) {
            this.submit({match: this.model});
        }
    }

    autocomplete(search) {
        if (this.omitNextAutocomplete) {
            this.omitNextAutocomplete = false;
            return;
        }

        this.showOptions = false;
        this.filteredOptions = [];

        const matches = [];
        
        if (search == '') return;
        angular.forEach(this.options, (o) => {
            name = o.name.toString();
            const index = name.toLowerCase().indexOf(search.toLowerCase());

            if (index < 0)
                return;

            const text = `${name.substring(0, index)}<em>${name.substring(index, index + search.length)}</em>${name.substring(index + search.length, name.length)}`;

            matches.push({
                value: name,
                rawMatch: o,
                offset: index,
                left: name.length - index - search.length,
                text: this.$sce.trustAsHtml(text)
            });
        });

        if (matches.length > 0) {
            this.showOptions = true;
            this.filteredOptions = this.$filter('orderBy')(matches, ['offset', 'left'], false);
        }
    }

    keyEvent(e) {
        if (!this.filteredOptions) return;

        switch (e.keyCode) {
            case 38:
                this.selected--;
                if (this.selected < 0) {
                    this.selected = this.filteredOptions.length - 1;
                }
                break;
            case 40:
                this.selected++;
                if (this.selected >= this.filteredOptions.length) {
                    this.selected = 0;
                }
                break;
            case 13:
                if (angular.isDefined(this.filteredOptions[this.selected])) {
                    this.clickOption(this.filteredOptions[this.selected].rawMatch);
                } else {
                    if (this.submit && this.model != '') {
                        this.submit({match: this.model});
                    }
                }
                break;
        }
    }
}

export default AutocompleteDirective;